export const ACADEMY_ONBOARDING_SECTION_IDS = {
  nextSteps: 'next-steps',
  liveEvents: 'live-events',
  learningResources: 'learning-resources'
};
export const ACADEMY_ONBOARDING_SECTION_IDS_SET = new Set(Object.values(ACADEMY_ONBOARDING_SECTION_IDS));
export const ACADEMY_ONBOARDING_SECTION_SCROLL_MARGIN = '80px';